import { IcSpinner } from '@magnetic/icons';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const ButtonLoaderIcon = /* @__PURE__ */ __name(({
  icon,
  loading
}) => {
  if (loading) {
    return /* @__PURE__ */ React.createElement(IcSpinner, { className: "mds-button-loading-icon", height: "16", width: "16" });
  }
  if (icon) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, icon);
  }
  return null;
}, "ButtonLoaderIcon");

export { ButtonLoaderIcon };
//# sourceMappingURL=button-loader-icon.js.map
